import React, { useRef, useState } from "react";

function WelcomeBannerWithVideo() {
  const videoRef = useRef(null);
  const [soundEnabled, setSoundEnabled] = useState(false);

  const enableSound = () => {
    const video = videoRef.current;
    if (video) {
      video.muted = false;
      video.play();
      setSoundEnabled(true);
    }
  };

  return (
    <div style={{ position: "relative", textAlign: "center" }}>
      <video
        ref={videoRef}
        autoPlay
        muted
        loop
        playsInline
        style={{
          maxWidth: "90vw",
          maxHeight: "80vh",
          borderRadius: "20px",
          boxShadow: "0 0 20px rgba(0,0,0,0.3)",
        }}
      >
        <source
          src="https://yaasaai.com/offerpopup/reel 15.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      {!soundEnabled && (
        <button
          onClick={enableSound}
          style={{
            position: "absolute",
            bottom: "-60px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#ff4d4f",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "20px",
            fontSize: "16px",
            fontWeight: "bold",
            border: "none",
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
            cursor: "pointer",
            zIndex: 10000,
          }}
        >
          🔊 Play with Sound
        </button>
      )}
    </div>
  );
}

export default WelcomeBannerWithVideo;
